import React, { FC } from "react";
import { Drawer, DrawerProps } from "@mui/material";

const DrawerWrapper: FC<DrawerProps> = ({ ...props }) => <Drawer {...props}/>

export default DrawerWrapper;
